import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { EmptyState, Table } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { useHubspotWorkflowViewContext } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView/context/context'
import styles from './styles.module.scss'
import { getColumns } from './getColumns'

export const HubspotWorkflowStatisticsTable = observer(() => {
  const {
    contactStatisticsItems,
    isNoContactData,
    total,
    isContactLoading,
    onPaginationTableChange,
    page,
    limit,
    contactStatisticsTableStore,
    onOpenContactsDetails,
  } = useHubspotWorkflowViewContext()
  const columns = useMemo(() => getColumns(onOpenContactsDetails), [])

  if (isNoContactData) {
    return (
      <EmptyState text={'No contacts found'} noIcon boxProps={{ flexGrow: 1, height: undefined }} />
    )
  }

  if (!isContactLoading && !contactStatisticsItems.length) {
    return <NoResultsFound boxProps={{ flexGrow: 1, height: undefined }} />
  }

  return (
    <div className={styles.wrapTable}>
      <Table
        ariaLabel={'HubspotWorkflowStatisticsTable'}
        columns={columns}
        rows={contactStatisticsItems}
        rowsCount={total}
        isLoading={isContactLoading}
        onChangePagination={onPaginationTableChange}
        initPage={page}
        limit={limit}
        startPaginationSize={10}
        store={contactStatisticsTableStore}
        defaultMaxWidthColumn={284}
        virtualization
      />
    </div>
  )
})
